import React, { PropTypes } from 'react'
import Table from 'react-bootstrap/lib/Table'

import AssignedCourseItem from './assigned-course-item'

const AssignedCourses = ({ items, onSelectItem }) => (
  <Table hover>
    <thead>
      <tr>
        <th width="20">#</th>
        <th width="10">{' '}</th>
        <th>Course Code</th>
        <th>Course Name</th>
        <th>College</th>
        <th>Chairman</th>
      </tr>
    </thead>
    <tbody>
      {items.map((item, k) => (
        <AssignedCourseItem
          key={item.get('id')}
          k={k}
          item={item}
          onSelectItem={onSelectItem}
        />
      ))}
    </tbody>
  </Table>
)

AssignedCourses.propTypes = {
  items: PropTypes.object,
  onSelectItem: PropTypes.func,
}

export default AssignedCourses



// WEBPACK FOOTER //
// ./src/containers/Setup/Courses/assigned-courses.js